<template>
    <div>
        <el-form ref="form" :inline="true" class="query-form" size="mini">
            <el-form-item label="" prop="status">
                <el-radio-group v-model="query.dataRange">
                    <el-radio-button :label="7">近7天</el-radio-button>
                    <el-radio-button :label="30">近30天</el-radio-button>
                    <el-radio-button :label="90">近90天</el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="开始时间：">
                <el-date-picker
                    style="width: 140px"
                    v-model="query.begin_date"
                    type="date"
                    size="mini"
                    placeholder="选择开始时间"
                    value-format="yyyy-MM-dd"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间：">
                <el-date-picker
                    style="width: 140px"
                    v-model="query.end_date"
                    type="date"
                    size="mini"
                    placeholder="选择结束时间"
                    value-format="yyyy-MM-dd"
                >
                </el-date-picker>
            </el-form-item>

            <!--            <el-form-item label="国家: " class="query-form-item" prop="state">-->
            <!--                <el-select v-model="query.category_state" style="width: 150px;" size="mini" filterable>-->
            <!--                    <el-option v-for="item in us_arr" :key="item.us" :label="item.title" :value="item.us"-->
            <!--                               :disabled="item.disabled">-->
            <!--                        <div class="keywords_arr_div">-->
            <!--                            <icon-svg :icon-class="item.us.toUpperCase()"-->
            <!--                                      style="font-size: 24px;margin-right:5px;"></icon-svg>-->
            <!--                            <span style="font-weight: 700; font-size: 14px;margin-left: 10px;">{{-->
            <!--                                    item.title-->
            <!--                                }}</span>-->
            <!--                        </div>-->
            <!--                    </el-option>-->
            <!--                </el-select>-->
            <!--            </el-form-item>-->
            <!--            <el-form-item label="类目：" class="query-form-item" prop="developer_id">-->
            <!--                <el-select v-model="query.category_id" placeholder="请选择" size="mini" filterable>-->
            <!--                    <el-option label="全部" value=""></el-option>-->
            <!--                    <el-option :label="item.name" :value="item.id" v-for="item in categoryList"></el-option>-->
            <!--                </el-select>-->
            <!--            </el-form-item>-->
            <el-button type="primary" @click="onSubmit" size="mini">查询</el-button>
        </el-form>
        <el-table v-loading="loading" :data="list" :height="tableHeight" size="mini" ref="multipleTable"
                  @row-click="clickRowHandle" @header-click="clickHeaderHandle"
                  @selection-change="handleSelectionChange"
                  class="table_content mini_div" border @sort-change="handleSortChange" style="width: 100%;">

            <el-table-column label="账号" min-width="120" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.username }}</div>

                </template>
            </el-table-column>
            <el-table-column label="人员" min-width="120" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.full_name }}</div>

                </template>
            </el-table-column>
            <el-table-column label="国家" min-width="20" align="center">
                <template slot-scope="scope">

                    <div v-for="preStr in prefixArr">
                        {{ prefixObj[preStr] }}
                    </div>

                </template>
            </el-table-column>

            <el-table-column label="总数" width="150" align="center">
                <template slot-scope="scope">

                    <div v-for="preStr in prefixArr">
                        {{ scope.row.end_date_datas[preStr + '_total_count'] }}

                        <span v-if="getNumDiff(scope.row, '_total_count', preStr)['flag']"
                              :class="{'greenTxt': (getNumDiff(scope.row, '_total_count', preStr)['num'] > 0),
                          'redTxt':((getNumDiff(scope.row, '_total_count', preStr)['num'] || 0) < 0) }">
                        (
                            {{ getNumDiff(scope.row, '_total_count', preStr)['num'] }}
                            <i class="el-icon-top"
                               v-show="getNumDiff(scope.row, '_total_count', preStr)['num'] > 0"/>
                            <i class="el-icon-bottom"
                               v-show="getNumDiff(scope.row, '_total_count', preStr)['num'] < 0"/>
                                )
                        </span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="未开始运营(利润符合)" width="150" align="center">
                <template slot-scope="scope">

                    <div v-for="preStr in prefixArr">
                        {{ scope.row.end_date_datas[preStr + '_pending_profit_y_count'] }}

                        <span v-if="getNumDiff(scope.row, '_pending_profit_y_count', preStr)['flag']"
                              :class="{'greenTxt': (getNumDiff(scope.row, '_pending_profit_y_count', preStr)['num'] > 0),
                          'redTxt':((getNumDiff(scope.row, '_pending_profit_y_count', preStr)['num'] || 0) < 0) }">
                        (
                            {{ getNumDiff(scope.row, '_pending_profit_y_count', preStr)['num'] }}
                            <i class="el-icon-top"
                               v-show="getNumDiff(scope.row, '_pending_profit_y_count', preStr)['num'] > 0"/>
                            <i class="el-icon-bottom"
                               v-show="getNumDiff(scope.row, '_pending_profit_y_count', preStr)['num'] < 0"/>
                                )
                        </span>
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="未开始运营(利润不符)" width="150" align="center">
                <template slot-scope="scope">

                    <div v-for="preStr in prefixArr">
                        {{ scope.row.end_date_datas[preStr + '_pending_profit_n_count'] }}

                        <span v-if="getNumDiff(scope.row, '_pending_profit_n_count', preStr)['flag']"
                              :class="{'greenTxt': (getNumDiff(scope.row, '_pending_profit_n_count', preStr)['num'] > 0),
                          'redTxt':((getNumDiff(scope.row, '_pending_profit_n_count', preStr)['num'] || 0) < 0) }">
                        (
                            {{ getNumDiff(scope.row, '_pending_profit_n_count', preStr)['num'] }}
                            <i class="el-icon-top"
                               v-show="getNumDiff(scope.row, '_pending_profit_n_count', preStr)['num'] > 0"/>
                            <i class="el-icon-bottom"
                               v-show="getNumDiff(scope.row, '_pending_profit_n_count', preStr)['num'] < 0"/>
                                )
                        </span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="运营中(利润符合)" width="150" align="center">
                <template slot-scope="scope">

                    <div v-for="preStr in prefixArr">
                        {{ scope.row.end_date_datas[preStr + '_running_profit_y_count'] }}

                        <span v-if="getNumDiff(scope.row, '_running_profit_y_count', preStr)['flag']"
                              :class="{'greenTxt': (getNumDiff(scope.row, '_running_profit_y_count', preStr)['num'] > 0),
                          'redTxt':((getNumDiff(scope.row, '_running_profit_y_count', preStr)['num'] || 0) < 0) }">
                        (
                            {{ getNumDiff(scope.row, '_running_profit_y_count', preStr)['num'] }}
                            <i class="el-icon-top"
                               v-show="getNumDiff(scope.row, '_running_profit_y_count', preStr)['num'] > 0"/>
                            <i class="el-icon-bottom"
                               v-show="getNumDiff(scope.row, '_running_profit_y_count', preStr)['num'] < 0"/>
                                )
                        </span>
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="运营中(利润不符)" width="150" align="center">
                <template slot-scope="scope">

                    <div v-for="preStr in prefixArr">
                        {{ scope.row.end_date_datas[preStr + '_running_profit_n_count'] }}

                        <span v-if="getNumDiff(scope.row, '_running_profit_n_count', preStr)['flag']"
                              :class="{'greenTxt': (getNumDiff(scope.row, '_running_profit_n_count', preStr)['num'] > 0),
                          'redTxt':((getNumDiff(scope.row, '_running_profit_n_count', preStr)['num'] || 0) < 0) }">
                        (
                            {{ getNumDiff(scope.row, '_running_profit_n_count', preStr)['num'] }}
                            <i class="el-icon-top"
                               v-show="getNumDiff(scope.row, '_running_profit_n_count', preStr)['num'] > 0"/>
                            <i class="el-icon-bottom"
                               v-show="getNumDiff(scope.row, '_running_profit_n_count', preStr)['num'] < 0"/>
                                )
                        </span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="不再运营" width="150" align="center">
                <template slot-scope="scope">

                    <div v-for="preStr in prefixArr">
                        {{ scope.row.end_date_datas[preStr + '_stopped_count'] }}

                        <span v-if="getNumDiff(scope.row, '_stopped_count', preStr)['flag']"
                              :class="{'greenTxt': (getNumDiff(scope.row, '_stopped_count', preStr)['num'] > 0),
                          'redTxt':((getNumDiff(scope.row, '_stopped_count', preStr)['num'] || 0) < 0) }">
                        (
                            {{ getNumDiff(scope.row, '_stopped_count', preStr)['num'] }}
                            <i class="el-icon-top"
                               v-show="getNumDiff(scope.row, '_stopped_count', preStr)['num'] > 0"/>
                            <i class="el-icon-bottom"
                               v-show="getNumDiff(scope.row, '_stopped_count', preStr)['num'] < 0"/>
                                )
                        </span>
                    </div>
                </template>
            </el-table-column>


        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="query.limit"
                       :page-sizes="[10, 20, 50]" :total="query.total" background :current-page="query.page"
                       style="margin-top: 10px; display: flex;justify-content: end;"
                       layout="total, sizes, prev, pager, next">
        </el-pagination>
    </div>
</template>

<script>
import * as api from '@/api/advAnalys/advAnalys.js'
import {downloadFileUrl} from '@/utils/method'
import {
    manager_statistics_statistics_category,
    manager_statistics_statistics_developer,
    manager_statistics_statistics_operator,
    operation_index_personal_statistics_operator
} from '@/api/advAnalys/advAnalys.js'

let timer = null
export default {
    name: 'categoryStatistics',
    watch: {
        tableHeight(val) {
            this.tableHeight = val
        },
        'query.dataRange': {
            handler(value) {
                value = value - 1
                this.query.begin_date = new Date(Date.now() - value * 24 * 60 * 60 * 1000)
                this.query.end_date = new Date()
                this.getList()
            },
            immediate: true,
            deep: true
        }
    },
    data() {
        return {
            prefixObj: {
                us: '美',
                uk: '英',
                de: '德',
                ev: '总'
            },
            prefixArr: ['us', 'uk', 'de', 'ev'],
            categoryList: [],
            peopleListVisible: false,
            rootCategoryList: [],
            usList: [],
            ukList: [],
            deList: [],
            imgStatusList: [
                {name: '全部', value: undefined},
                {name: '搜索不到图片', value: 1},
                {name: '暂无图片', value: 2},
                {name: '有图片', value: 3},
            ],
            isFold: true,
            editType: 0,
            copyData: {},
            manualRootShow: false,
            showBasicConfigDataModal: false,
            showAddParseModal: false,
            showCategoryList: false,
            manualRootList: [],
            showAddRecord: false,
            currentId: '',
            tableHeight: null,
            errorMsg: '',
            errorInfoShow: false,
            ctrl: {
                DownloadListDialogVisible: false,
                uploadDialogVisible: false,
                bidDialogVisible: false,
                childInfoVisible: false,
            },
            query: {
                dataRange: 7,
                begin_date: undefined,
                end_date: undefined,
                category_state: '',
                category_id: '',
                page: 1,
                limit: 10,
                total: 0,
            },
            record_id: 0,
            activeName: 'antiInternal',
            list: [],
            disabled: false,
            listDisabled: false,
            loading: false,
            parseStatusList: [],
            updateData: {},
            childInfo: {},
            multipleSelection: [],
        }
    },
    mounted() {
        this.getCategoryList()
        this.tableHeight =
            window.innerHeight - 140 - this.$refs.form.$el.offsetHeight
        const that = this
        window.onresize = () => {
            return (() => {
                if (typeof that.$refs.form == 'object') {
                    that.tableHeight =
                        window.innerHeight -
                        140 -
                        that.$refs.form.$el.offsetHeight
                }
            })()
        }
    },
    destroyed() {
        clearInterval(timer)
    },
    methods: {
        getNumDiff(obj, variableStr, preStr) {
            let res = {flag: false, num: 0}
            if (obj.begin_date_datas && obj.end_date_datas) {
                res = {
                    flag: true,
                    num: obj.end_date_datas[preStr + variableStr] - obj.begin_date_datas[preStr + variableStr]
                }
            }
            return res
        },
        getCategoryList() {
            api.manager_index_get_category_message().then(res => {
                this.loading = false
                if (res.code === 0) {
                    this.categoryList = res.data || []
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            }).catch(() => {
                this.loading = false
            })
        },

        detailFunc(data) {
            this.$refs.detailPreview.visible = true
            this.$refs.detailPreview.title = '详情展示'
            this.$refs.detailPreview.formData = data
        },
        // 取消分配
        unassignFunc(data) {
            api.cost_analysis_personal_cancel_assign({id: data.id}).then((res) => {
                if (res.success) {
                    this.$message.success('取消分配成功')
                    this.getList()
                } else {
                    this.$message.error('取消分配失败，请联系管理员')
                }
            })
        },
        // 操作
        operateFunc(data, type) {
            let tempDate = JSON.parse(JSON.stringify(data))
            this.editType = type
            this.copyData = tempDate
            this.showAddRecord = true
        },
        // 采购
        toMeFunc(data) {
            this.multipleSelection = [data.id]
            this.onBatchDistribution()
        },
        // 关闭弹窗
        handleClose(isshow = false) {
            this.loading = false
            this.$emit('close-callback', isshow)
        },
        handleSelectionChange(val) {
            let arr = []
            val.map(v => {
                arr.push(v.id)
            })
            arr = Array.from(new Set(arr))
            this.multipleSelection = arr
        },
        seeUrl(row) {
            this.childInfo.title = '1688链接'
            this.childInfo.info = row.href_link
            this.ctrl.childInfoVisible = true
        },
        jumpUrl(url) {
            window.open(url, '_blank')
        },
        //跳转到亚马逊产品页面
        edirectToAsin(data) {
            // let url =
            //     link_us(data.state) +
            //     'dp/' +
            //     data.url_asin_href +
            //     '?th=1&psc=1'
            window.open(data.href_link, '_blank')
        },
        /**
         * 数字相乘
         * @param {*} arg1
         * @param {*} arg2
         * @returns
         */
        accMul(arg1, arg2) {
            let m = 0
            m = this.accAdd(m, this.getDecimalLength(arg1))
            m = this.accAdd(m, this.getDecimalLength(arg2))
            return this.getNum(arg1) * this.getNum(arg2) / Math.pow(10, m)
        },
        getNum(arg = '') {
            return Number(arg.toString().replace('.', ''))
        },
        /**
         * 数字相加
         * @param {*} arg1
         * @param {*} arg2
         * @returns
         */
        accAdd(arg1, arg2) {
            return this.changeNum(arg1, arg2)
        },
        changeNum(arg1 = '', arg2 = '', isAdd = true) {
            const changeInteger = (arg, r, maxR) => {
                if (r != maxR) {
                    let addZero = ''
                    for (let i = 0; i < maxR - r; i++) {
                        addZero += '0'
                    }
                    arg = Number(arg.toString().replace('.', '') + addZero)
                } else {
                    arg = this.getNum(arg)
                }
                return arg
            }

            let r1, r2, maxR, m
            r1 = this.getDecimalLength(arg1)
            r2 = this.getDecimalLength(arg2)
            maxR = Math.max(r1, r2)
            arg1 = changeInteger(arg1, r1, maxR)
            arg2 = changeInteger(arg2, r2, maxR)
            m = Math.pow(10, maxR)
            if (isAdd) {
                return (arg1 + arg2) / m
            } else {
                return (arg1 - arg2) / m
            }
        },

        getDecimalLength(arg = '') {
            try {
                return arg.toString().split('.')[1].length
            } catch (e) {
                return 0
            }
        },

        spanMethod({row, column, rowIndex, columnIndex}) {

            const columns = [13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28]
            if (rowIndex % 3 == 0) {
                if (columns.includes(columnIndex)) {
                    return {
                        rowspan: 1,
                        colspan: 1
                    }
                }
                return {
                    rowspan: 3,
                    colspan: 1
                }
            } else {
                if (columns.includes(columnIndex)) {
                    return {
                        rowspan: 1,
                        colspan: 1
                    }
                }
                return {
                    rowspan: 0,
                    colspan: 0
                }
            }
        },
        copyDataFunc(data, type) {
            this.showAddRecord = true
            let tempDate = JSON.parse(JSON.stringify(data))
            tempDate.is_peak_season = tempDate.is_peak_season == 1 ? true : false
            tempDate.is_seasonality = tempDate.is_seasonality == 1 ? true : false
            this.editType = type
            this.copyData = tempDate
        },
        delete_records(data) {
            this.$confirm('确认删除该记录吗?', '提示', {
                type: 'warning'
            }).then(() => {
                api.variety_cost_control_analysis_delete({ids: [data.id]}).then(() => {
                    this.$message.success('删除成功')
                    this.getList()
                })
            })
        },
        showErrorInfo(info) {
            this.errorInfoShow = true
            this.errorMsg = info.parsing_err_msg
        },
        showManualRoot(info) {
            this.manualRootShow = true
            this.manualRootList = info
        },
        getList() {
            this.loading = true
            let tempQuery = JSON.parse(JSON.stringify(this.query))
            tempQuery.begin_date = this.formatDate(new Date(tempQuery.begin_date))
            tempQuery.end_date = this.formatDate(new Date(tempQuery.end_date))
            api.operation_index_personal_statistics_operator(tempQuery).then(res => {
                this.loading = false
                if (res.code === 0) {
                    const responseList = res.data.list || []
                    this.list = responseList
                    this.query.total = res.data.total
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            }).catch(() => {
                this.loading = false
            })
        },
        formatDate(date) {
            const yyyy = date.getFullYear()
            const mm = String(date.getMonth() + 1).padStart(2, '0') // 月份从0开始，所以要加1
            const dd = String(date.getDate()).padStart(2, '0')
            return `${yyyy}-${mm}-${dd}`
        },
        clickRowHandle(row, column) {
            if (['标题', '类目树', '子类目', '1688产品标题', '颜色'].includes(column.label)) {
                this.childInfo.title = column.label
                let info = row.title
                if (column.label == '类目树') {
                    info = row.category_tree
                } else if (column.label == '子类目') {
                    info = row.categories_str
                } else if (column.label == '颜色') {
                    info = row.color
                } else if (column.label == '1688产品标题') {
                    info = row.ali_title
                }
                this.childInfo.info = info
                this.ctrl.childInfoVisible = true
            }
            if (['折叠', '收起'].includes(column.label)) {
                this.isFold = !this.isFold
            }
        },
        clickHeaderHandle(row, column) {
            if (['折叠', '收起'].includes(row.label)) {
                this.isFold = !this.isFold
            }
        },
        handleSortChange(val) {
            if (val.order == 'ascending') {
                this.query.desc = 'desc'
                this.query.order = val.prop
            } else if (val.order == 'descending') {
                this.query.desc = 'asc'
                this.query.order = val.prop
            }
            this.getList()
        },
        handleClick(tab) {
            this.$nextTick(() => {
                this.$refs[tab.paneName].getList()
            })
        },
        //重置
        onReset() {
            this.query = {
                dataRange: 7,
                begin_date: undefined,
                end_date: undefined,
                category_state: '',
                category_id: '',
                page: 1,
                limit: 10,
                total: 0,
            }
            this.getList()
        },
        onBatchDistribution() {
            if (this.multipleSelection.length > 0) {
                this.peopleListVisible = true
            } else {
                this.$message.info('暂未选择批量处理内容')
            }
        },
        //查询
        onSubmit() {
            this.query.page = 1
            this.getList()
        },
        basicData() {
            this.showBasicConfigDataModal = true
        },
        addParse() {
            this.showAddParseModal = true
        },
        // 批量删除
        batchDelete() {
            if (this.multipleSelection.length > 0) {
                this.$confirm(`确定批量删除已选择项吗?`, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    api.variety_cost_control_analysis_delete({ids: this.multipleSelection}).then(res => {
                        if (res.code === 0) {
                            this.$message({type: 'success', message: '删除成功'})
                            this.getList()
                        } else {
                            this.$message({type: 'error', message: res.message})
                        }
                    }).catch(res => {
                        this.$message({type: 'error', message: res.message})
                    })
                }).catch(() => {
                })

            } else {
                this.$message.info('暂未选择批量处理内容')
            }
        },
        // 批量重置
        batchReset() {
            if (this.multipleSelection.length > 0) {
                this.$confirm(`确定批量重置已选择项吗?`, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    api.variety_cost_control_analysis_batch_reset({ids: this.multipleSelection}).then(res => {
                        if (res.code === 0) {
                            this.$message({type: 'success', message: '重置成功'})
                            this.getList()
                        } else {
                            this.$message({type: 'error', message: res.message})
                        }
                    }).catch(res => {
                        this.$message({type: 'error', message: res.message})
                    })
                }).catch(() => {
                })

            } else {
                this.$message.info('暂未选择批量处理内容')
            }
        },

        change() {
            this.getList()
        },
        clearValue() {
            this.query.state = ''
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val
            this.getList()
        },
        handleSizeChange(val) {
            this.query.limit = val
            this.getList()
        },
        //上传文件
        onupload() {
            this.ctrl.uploadDialogVisible = true
        },
        //下载列表
        onDownloadList() {
            this.ctrl.DownloadListDialogVisible = true
            this.$nextTick(() => {
                this.$refs[this.activeName].getList()
            })
        },
        // bid记录列表
        openBidList(data) {
            this.currentId = data.id
            this.ctrl.bidDialogVisible = true
        },
        async startDecode(row, force = 0) {
            if (force) {
                await this.$confirm('是否重新运行解析任务', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
            }
            let list = JSON.parse(JSON.stringify(this.list))
            api.variety_cost_control_analysis_parsing_file({
                id: row.id,
                force
            }).then(() => {
                const index = list.findIndex(item => item.id === row.id)
                list[index].status = 1
                this.list = list
            })
        },
        downFile(path) {
            if (!path) {
                return this.$message({
                    type: 'error',
                    message: '无法下载！'
                })
            }
            downloadFileUrl(path)
        },
        //添加广告优化记录
        onAddPpc(data) {
            this.record_id = data.id
            this.ctrl.addPpcDialogVisible = true
        },
        // 关闭弹窗回调
        closeCllback(isShow) {
            this.showAddRecord = false
            this.showAddParseModal = false
            this.ctrl.childInfoVisible = false
            this.updateData = {}
            isShow == true && this.getList()
        },
        // 关闭弹窗回调
        chooseDevelopCloseCallback(arr) {
            this.peopleListVisible = false
            if (arr.length > 0) {
                api.manager_cost_analysis_manager_batch_distribution({
                    ids: this.multipleSelection,
                    developer_id: arr[0]
                }).then(res => {
                    if (res.code === 0) {
                        this.$message.success('分配成功')
                        this.getList()
                    } else {
                        this.$message({type: 'error', message: res.message})
                    }
                }).catch(res => {
                    this.$message({type: 'error', message: res.message})
                })
            }
        },
        refreshList() {
            this.getList()
        },
        update(data) {
            this.updateData = data
            this.showAddRecord = true
        }
    }
}
</script>

<style type="text/scss" lang="scss" scoped>
.redTxt {
    color: red;
    font-weight: bold;
}

.greenTxt {
    color: green;
    font-weight: bold;
}

.fixedHeight {
    height: 30px;
    line-height: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    display: flex;
    justify-content: center;
    align-items: center;
}

.mini_div .el-button--mini {
    padding: 5px 5px !important;
}

/deep/ .el-table__expanded-cell {
    padding: 0 0 !important;
}
</style>
